<div class="container">
    <div class="">
        <img src="/assets/img/paymentsuccess.gif" alt="">
    </div>

    <div class="successfull-text">You are payment has been successfull</div>
</div>
